import React from "react";
import { getInstantValidationState } from '../../../utils/realTimeValidationUtils';

import './StandardEarlyPostOp.scss';

const StandardEarlyPostOp = ({ handleFormData, values, fieldErrors = {}, touchedFields = {} }) => {
  return (
    <div className="modern-assessment">
      <h2 className="assessment-title">Standaard Vroeg Post-operatief Formulier</h2>
      {(() => {
        const validation = getInstantValidationState('sepostop.sepostopQuestion1', fieldErrors, touchedFields, values.sepostop.sepostopQuestion1);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              1. Gebruikt u pijnmedicatie op recept vanwege uw recente operatie/behandeling?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="sepostopQuestion1"
              required
              value={values.sepostop.sepostopQuestion1}
              onChange={(event) => handleFormData("sepostop", "sepostopQuestion1", event.target.value)}
              aria-label="Gebruik pijnmedicatie op recept"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
            </select>
            
          </div>
        );
      })()}    

      {(() => {
        const validation = getInstantValidationState('sepostop.sepostopQuestion2', fieldErrors, touchedFields, values.sepostop.sepostopQuestion2);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              2. Gebruikt u vrij verkrijgbare pijnmedicatie (Aspirine, Advil, Tylenol enz.) vanwege uw recente operatie/behandeling?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="sepostopQuestion2"
              required
              value={values.sepostop.sepostopQuestion2}
              onChange={(event) => handleFormData("sepostop", "sepostopQuestion2", event.target.value)}
              aria-label="Gebruik vrij verkrijgbare pijnmedicatie"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('sepostop.sepostopQuestion3', fieldErrors, touchedFields, values.sepostop.sepostopQuestion3);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              3. Gebruikt u slaapmedicatie vanwege het ongemak door uw recente operatie/behandeling?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="sepostopQuestion3"
              required
              value={values.sepostop.sepostopQuestion3}
              onChange={(event) => handleFormData("sepostop", "sepostopQuestion3", event.target.value)}
              aria-label="Gebruik slaapmedicatie"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
            </select>
            
          </div>
        );
      })()}
    </div>
  );
}

export default StandardEarlyPostOp;
